/**
 * @generated SignedSource<<54943547663db0dc6402747435215aba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type LearnableKind = "Course" | "GroupCoaching" | "MicroLearning" | "OneToOneCoaching";
import { FragmentRefs } from "relay-runtime";
export type gridView_QueryFragment$data = {
  readonly Learnable: {
    readonly PublishedLearnables: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly kind: LearnableKind;
          readonly " $fragmentSpreads": FragmentRefs<"gridView_PublishedLearnableFragment">;
        };
      } | null> | null;
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"tags_AcademiesRooTagsConnectionFragment">;
  readonly " $fragmentType": "gridView_QueryFragment";
};
export type gridView_QueryFragment$key = {
  readonly " $data"?: gridView_QueryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"gridView_QueryFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "Learnable",
  "PublishedLearnables"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "before"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "kinds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "last"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tagIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "text"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "bidirectional",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": {
          "count": "last",
          "cursor": "before"
        },
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": require('./gridViewRefetchQuery.graphql')
    }
  },
  "name": "gridView_QueryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LearnableQueries",
      "kind": "LinkedField",
      "name": "Learnable",
      "plural": false,
      "selections": [
        {
          "alias": "PublishedLearnables",
          "args": [
            {
              "kind": "Variable",
              "name": "kinds",
              "variableName": "kinds"
            },
            {
              "kind": "Variable",
              "name": "tagIds",
              "variableName": "tagIds"
            },
            {
              "kind": "Variable",
              "name": "text",
              "variableName": "text"
            }
          ],
          "concreteType": "PublishedLearnablesConnection",
          "kind": "LinkedField",
          "name": "__gridView_PublishedLearnables_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PublishedLearnablesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v2/*: any*/),
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "gridView_PublishedLearnableFragment",
                      "selections": [
                        (v2/*: any*/),
                        (v1/*: any*/),
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "coachingLearnableCard_PublishedLearnableFragment"
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "educationalOfferCard_PublishedCourseLearnableFragment"
                        }
                      ],
                      "args": null,
                      "argumentDefinitions": []
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "tags_AcademiesRooTagsConnectionFragment"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "f3e3426347fa87b506bf7b23a97b70da";

export default node;
